import React, { useState } from "react";
import "./Tooltip.css";
export var Tooltip = function (props) {
    var timeout;
    var _a = useState(false), active = _a[0], setActive = _a[1];
    var showTip = function () {
        timeout = setTimeout(function () {
            setActive(true);
        }, props.delay || 400);
    };
    var hideTip = function () {
        clearInterval(timeout);
        setActive(false);
    };
    return (React.createElement("div", { className: "Tooltip-Wrapper", 
        // When to show the tooltip
        onMouseEnter: showTip, onMouseLeave: hideTip },
        props.children,
        active && !props.disabled && (React.createElement("div", { className: "Tooltip-Tip ".concat(props.direction || "top") }, props.content))));
};
